import React, { useEffect, useState } from "react";
import { SafeAreaView, View, StyleSheet, Modal } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { clearError } from "../../actions";
import { Text } from "../../components/Text";
import { errorsSelector } from "@/app/selectors";
import { colors, fontSizes } from "@/app/constants/styles";
import { TouchableOpacity } from "@/app/components/Buttons";

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { errors } = useSelector(errorsSelector);
  const [showModal, setShowModal] = useState(true);

  useEffect(() => setShowModal(errors && errors.length > 0), [errors]);

  const handleClose = () => {
    setShowModal(false);
    dispatch(clearError());
  };

  return errors && errors.length > 0 ? (
    <Modal
      transparent={true}
      visible={showModal}
      onRequestClose={handleClose}
      animationType="fade"
    >
      <TouchableOpacity style={styles.modalOverlay} onPress={handleClose}>
        <SafeAreaView style={styles.errorContainer}>
          <View
            style={styles.contentContainer}
            accessible={true}
            accessibilityRole="alert"
          >
            {errors.map((error, index) => (
              <Text
                key={index.toString()}
                style={styles.errorText}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={`Error message: ${error}`}
              >
                {error}
              </Text>
            ))}
            <TouchableOpacity
              onPress={handleClose}
              style={styles.closeButton}
              accessible={true}
              accessibilityRole="button"
              accessibilityLabel="Close error message"
              accessibilityHint="Dismisses the error message"
            >
              <Text style={styles.closeButtonText}>Close</Text>
            </TouchableOpacity>
          </View>
        </SafeAreaView>
      </TouchableOpacity>
    </Modal>
  ) : null;
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "flex-end",
  },
  errorContainer: {
    flex: 0,
    top: "40%",
    left: "20%",
    width: "60%",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.almostWhite,
    borderRadius: 10,
  },
  contentContainer: {
    width: "100%",
    alignItems: "center",
    padding: 20,
  },
  errorText: {
    fontSize: fontSizes.x14,
    fontFamily: "HelveticaNeue",
    color: colors.error,
    textAlign: "center",
    marginBottom: 10,
  },
  closeButton: {
    marginTop: 10,
    paddingVertical: 10,
    paddingHorizontal: 30,
    backgroundColor: colors.error,
    borderRadius: 4,
  },
  closeButtonText: {
    color: colors.white,
    fontSize: fontSizes.x16,
    fontFamily: "HelveticaNeue-Medium",
  },
});

export default ErrorModal;
